<style lang="stylus">
.category-card-rule {
  &.show-header {
    padding-top: 44px;
  }

  .card-rule-text {
    padding: 15px;

    h3:nth-child(1) {
      margin-top: 0px;
    }

    span {
      color: rgb(255,95,22);
    }

    ul {
      padding-left: 15px;

      li {
        color: rgb(121, 125, 130);
        font-size: 13px;
      }
    }

    h3 {
      font-size: 14px;
      color: rgb(25, 26, 27);
    }

    .applicable-cinema {
      color: rgb(71, 122, 172);
    }
  }
}
</style>
<template>
    <div :class="[isApp ? '' : 'show-header' , 'category-card-rule']">
        <my-header class="header" v-show="!isApp">
        </my-header>
        <div class="card-rule" v-if="cardDisplayType===1">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
              <li>可购买全场任意品类商品</li>
              <li>购买{{categoryName}}类商品可打折</li>
              <li>购买其他品类商品，不享受折扣</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ cardBalance | price }}</span>元，消费明细以此额度来计算</li>
              <li>购买{{ categoryName }}类商品可打<span>{{ rate }}</span>折，即可购买价值为<span>{{ maxConsumePrice| price }}</span>元的{{ categoryName }}类商品</li>
              <li>可购买价值为<span>{{ cardBalance | price }}</span>元的非{{ categoryName }}类商品</li>
            </ul>
          </div>
          <div v-show="isFilmCard" class="card-rule-text">
            <h3>线下兑换</h3>
            <ul>
                <li>可在全国范围内的影院前台兑换电影票</li>
                <li>点击查看<span class="applicable-cinema" @click="toCinema">线下可兑换影院</span></li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===2">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
              <li>购买{{categoryName}}类商品可打折</li>
              <li>购买其他品类商品，不享受折扣</li>
              <li>不可购买{{blackListName}}商品</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ cardBalance | price }}</span>元，消费明细以此额度来计算</li>
              <li>购买{{ categoryName }}类商品可打<span>{{ rate }}</span>折，即可购买价值为<span>{{ maxConsumePrice| price }}</span>元的{{ categoryName }}类商品</li>
              <li>可购买价值为<span>{{ cardBalance | price }}</span>元的非{{ categoryName }}类商品</li>
            </ul>
          </div>
          <div v-show="isFilmCard" class="card-rule-text">
            <h3>线下兑换</h3>
            <ul>
                <li>可在全国范围内的影院前台兑换电影票</li>
                <li>点击查看<span class="applicable-cinema" @click="toCinema">线下可兑换影院</span></li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===3">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
              <li>可购买全场任意品类商品（除{{blackListName}}类）</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ cardBalance | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
          <div v-show="isFilmCard" class="card-rule-text">
            <h3>线下兑换</h3>
            <ul>
                <li>可在全国范围内的影院前台兑换电影票</li>
                <li>点击查看<span class="applicable-cinema" @click="toCinema">线下可兑换影院</span></li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===4">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
              <li>可购买全场任意品类商品</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ cardBalance | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
          <div v-show="isFilmCard" class="card-rule-text">
            <h3>线下兑换</h3>
            <ul>
                <li>可在全国范围内的影院前台兑换电影票</li>
                <li>点击查看<span class="applicable-cinema" @click="toCinema">线下可兑换影院</span></li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===5">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
              <li>可购买{{categoryName}}类商品</li>
              <li>不可购买其他品类商品</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ maxConsumePrice | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
          <div v-show="isFilmCard" class="card-rule-text">
            <h3>线下兑换</h3>
            <ul>
                <li>可在全国范围内的影院前台兑换电影票</li>
                <li>点击查看<span class="applicable-cinema" @click="toCinema">线下可兑换影院</span></li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===6">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
              <li>可购买{{categoryName}}类商品</li>
              <li>不可购买其他品类商品</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ cardBalance | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
          <div v-show="isFilmCard" class="card-rule-text">
            <h3>线下兑换</h3>
            <ul>
                <li>可在全国范围内的影院前台兑换电影票</li>
                <li>点击查看<span class="applicable-cinema" @click="toCinema">线下可兑换影院</span></li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===7">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
                <li>可购买全场任意品类商品</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ maxConsumePrice | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===8">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
                <li>可购买全场任意品类商品</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ cardBalance | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===9">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
                <li>可购买全场任意品类商品（除{{blackListName}}类）</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ maxConsumePrice | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===10">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
                <li>可购买全场任意品类商品（除{{blackListName}}类）</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ cardBalance | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else-if="cardDisplayType===11">
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
                <li>可购买企业福利提货券专区内食品类商品</li>
            </ul>
          </div>
          <div class="card-rule-text nolimit">
            <h3>券内额度</h3>
            <ul>
              <li>券内余额为<span>{{ maxConsumePrice | price }}</span>元，消费明细以此额度来计算</li>
            </ul>
          </div>
        </div>

        <div class="card-rule" v-else>
          <div class="card-rule-text">
            <h3>购买范围</h3>
            <ul>
              <li>可购买苏打优选商城商品</li>
            </ul>
          </div>
        </div>
    </div>
</template>
<script>
import myHeader from "../../components/header.vue";
import { mapState } from "vuex";
import op from "object-path";
import _ from "underscore";
import { app } from "../../util/platform";
import CONSTANT from "../../constant/card";
import RSA from "../../util/RSA.js";
let rsa = new RSA();

export default {
  data() {
    return {
      CONST_BLACKLIST_TYPE_ALL_CAN_USE: 1, //无黑名单
      CONST_BLACKLTST_TYPE_SOME_CAN_USE: 2, //部分禁止使用
      CONST_BLACKLIST_TYPE_ONLY_MAIN: 3 //除了主品类，其他不可用
    };
  },
  components: {
    "my-header": myHeader
  },
  mounted() {
    if (_.isEmpty(this.card)) {
      this.$router.go(-1);
    }
  },
  computed: {
    ...mapState({
      card: state => state.card.cardDetail
    }),
    isApp() {
      return app.isMZFilm();
    },
    categoryName() {
      if (!this.isMultipleCategories) {
        return op(this.card).get("category.categoryName");
      }
      return this.mainCategoryName;
    },
    isNoLimit() {
      // 是否为商城通卡
      return (
        op(this.card).get("category.categoryId") == CONSTANT.CARD_CATEGORY_ALL
      );
    },
    isNoRate() {
      // 是否有折扣
      return op(this.card).get("category.rate") == 10;
    },
    cardBalance() {
      return op(this.card).get("cardBalance");
    },
    maxConsumePrice() {
      return op(this.card).get("category.maxConsumePrice");
    },
    rate() {
      return op(this.card).get("category.rate");
    },
    isFilmCard() {
      return (
        op(this.card).get("category.categoryId") === CONSTANT.CARD_CATEGORY_FILE
      );
    },
    isMultipleCategories() {
      return (
        op(this.card).get("category.categoryId") ===
        CONSTANT.CARD_CATEGORY_MULTIPLE
      );
    },
    isCategories() {
        let id = op(this.card).get("category.categoryId")
        return id !== CONSTANT.CARD_CATEGORY_ALL
    },
    isPickUpGoods() {
      return op(this.card).get("category.pickUpGoodsType") !==
        CONSTANT.CARD_PICKUP_GOODS_NOT
    },
    blackListType() {
      let hasBlackList =
        op(this.card).get("category.categoryBlackListType") === 1;
      if (hasBlackList) {
        if (_.isEmpty(op(this.card).get("category.categoryBlackList"))) {
          return this.CONST_BLACKLIST_TYPE_ONLY_MAIN;
        }
        return this.CONST_BLACKLTST_TYPE_SOME_CAN_USE;
      } else {
        return this.CONST_BLACKLIST_TYPE_ALL_CAN_USE;
      }
    },
    blackListName() {
      let list = op(this.card).get("category.categoryBlackList");

      if (_.isEmpty(list)) {
        return ''
      }

      return list
        .map(c => {
          return c.categoryName;
        })
        .reduce((previousValue, currentValue) => {
          return `${previousValue}、${currentValue}`;
        });
    },
    mainCategoryName() {
      let list = op(this.card).get("category.validCategoryList");

      if (_.isEmpty(list)) {
        return ''
      }

      return list
        .map(c => {
          return c.categoryName;
        })
        .reduce((previousValue, currentValue) => {
          return `${previousValue}、${currentValue}`;
        });
    },
    cardDisplayType() {
      // 主品类卡：
      //     1.多品类卡+无黑名单+有折扣
      //     2.多品类卡+有黑名单+有折扣
      //     3.多品类卡+有黑名单+无折扣
      //     4.多品类卡+无黑名单+无折扣
      // 单一品类卡：
      //     5.单一品类卡+有折扣
      //     6.单一品类卡+无折扣
      // 商城通：
      //     7.商城通+无黑名单+有折扣
      //     8.商城通+无黑名单+无折扣
      //     9.商城通+黑名单+有折扣
      //     10.商城通+黑名单+无折扣
      //     11.商城通+提货券
      // 特殊品类卡：
      //     1B.电影多品类卡+无黑名单+有折扣
      //     2B.电影多品类卡+有黑名单+有折扣
      //     3B.电影多品类卡+有黑名单+无折扣
      //     4B.电影多品类卡+无黑名单+无折扣
      //     5B.电影单一品类卡+有折扣
      //     6B.电影单一品类卡+无折扣
      //     0.默认
      // MORE DETAIL: https://shimo.im/docs/OwJ3N3iwoHwddOGF
      if (this.isCategories) {
        if (this.blackListType !== this.CONST_BLACKLIST_TYPE_ONLY_MAIN) {
          if (!this.isNoRate) {
            if (this.blackListType === this.CONST_BLACKLIST_TYPE_ALL_CAN_USE) {
              return 1;
            } else {
              return 2;
            }
          } else {
            if (this.blackListType === this.CONST_BLACKLTST_TYPE_SOME_CAN_USE) {
              return 3;
            } else {
              return 4;
            }
          }
        } else {
          if (!this.isNoRate) {
            return 5;
          } else {
            return 6;
          }
        }
      } else if (this.isNoLimit) {
        if (this.isPickUpGoods) {
          return 11;
        }
        if (this.blackListType === this.CONST_BLACKLIST_TYPE_ALL_CAN_USE) {
          if (!this.isNoRate) {
            return 7;
          } else {
            return 8;
          }
        } else {
          if (!this.isNoRate) {
            return 9;
          } else {
            return 10;
          }
        }
      }
      return 0;
    }
  },
  methods: {
    toCinema() {
      const cardDetail = this.$store.state.card.cardDetail;
      const contentData = cardDetail.contentData;
      const isCityLimit = op(cardDetail).get("ticketInfo.isCityLimit");
      if (this.$route.query && this.$route.query.type) {
        const type = this.$route.query.type;
        const content = encodeURIComponent(this.$route.query.content);
        this.$router.push(
          `/card/detail/limit/cinema?type=${type}&content=${content}&isCityLimit=${isCityLimit}&ticketCardType=${
            CONSTANT.TICKET_CARD_TYPE_CATEGORY
          }`
        );
        return;
      } else if (contentData && contentData.type) {
        this.$router.push(
          `/card/detail/limit/cinema?type=${contentData.type}&content=${
            contentData.content
          }&isCityLimit=${isCityLimit}&ticketCardType=${
            CONSTANT.TICKET_CARD_TYPE_CATEGORY
          }`
        );
        return;
      } else if (cardDetail.uniqueCardId) {
        this.$router.push(
          `/card/detail/limit/cinema?type=${3}&content=${encodeURIComponent(
            rsa.encrypt(cardDetail.uniqueCardId, "base64")
          )}&isCityLimit=${isCityLimit}&ticketCardType=${
            CONSTANT.TICKET_CARD_TYPE_CATEGORY
          }`
        );
        return;
      }
    }
  }
};
</script>
